// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__261H8","label":"Labeled_label__h1iBX","divider":"Labeled_divider__11FpG"};